import type { MenuExtendedProps } from "config/menus";
import { knowYourRightsMenu } from "config/menus";

export const airHelpPlusMenu: MenuExtendedProps[] = [
  {
    storyblokId: 282180211,
    label: "menu_join_airhelp_plus",
    dataQA: "top-navbar-ah-plus",
    trackingEvent: ["Menu", "AirHelpPlus"],
  },
  {
    storyblokId: 316891649,
    label: "menu_air_payout",
    trackingEvent: ["Menu", "AirPayout"],
  },
];

export const topMenuExperiment: MenuExtendedProps[] = [
  {
    page: "webappNewClaim",
    label: "check_compensation",
    trackingEvent: ["Menu", "CheckCompensation"],
    attributes: { rel: "nofollow" },
  },
  {
    subMenu: airHelpPlusMenu,
    label: "menu_airhelp_plus",
    dataQA: "top-navbar-ah-plus",
  },
  {
    storyblokId: 279912103,
    label: "menu_plan_your_trip",
    trackingEvent: ["Menu", "PlanYourTrip"],
    languages: [
      "en",
      "en-au",
      "en-ca",
      "en-gb",
      "en-in",
      "en-int",
      "en-ie",
      "en-nz",
      "de",
      "de-at",
      "de-ch",
      "es",
      "fr",
      "fr-ca",
      "it",
      "pl",
      "pt-br",
      "pt-pt",
      "ro",
      "ro-md",
    ],
  },
  {
    label: "menu_know_your_rights",
    subMenu: knowYourRightsMenu,
    dataQA: "top-navbar-kyr",
  },
  { storyblokId: 61788293, label: "menu_about_us", attributes: { rel: "nofollow" } },
];
